import { render } from "./InvoiceDetailFiscalSummaryCard.vue?vue&type=template&id=6015a68b&scoped=true"
import script from "./InvoiceDetailFiscalSummaryCard.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailFiscalSummaryCard.vue?vue&type=script&lang=js"

import "./InvoiceDetailFiscalSummaryCard.vue?vue&type=style&index=0&id=6015a68b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6015a68b"]])

export default __exports__